import { useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * ChenMed nudge engine v2 (code-mediated detection over live published protocol versions).
 * Inner flag nested under the ChenMed nudges flag. The flag KEY
 * `release-ml-scribe-chenmed-engine-v2` is the SAME key the backend evaluates — the BE reads it
 * through its `release_chenmed_engine_v2()` accessor (that's the Python function name, not a
 * second key), so FE dashboard gating and BE firing flip together off one flag. Gating the
 * dashboard on it makes the population that can CHANGE what fires (publish/take-offline) exactly
 * the population whose sessions read the live-version store — an off-flag admin must not govern
 * protocols they never see fire.
 *
 * Lives in this standalone `.ts` module (not the `index.tsx` barrel) so it does not add a
 * `react-refresh/only-export-components` warning to the component barrel. Import it through
 * `@/features/flags`, which re-exports it.
 */
export const useIsChenmedEngineV2Enabled = () => {
  return useBooleanFlagValue('release-ml-scribe-chenmed-engine-v2', false);
};
